document.addEventListener("DOMContentLoaded", function () {
  const faqSections = document.querySelectorAll(".js-faq-tabs");

  if (!faqSections.length) return;

  faqSections.forEach((section) => {
    const tabsWrapper = section.querySelector(".js-faqs-tabs-wrapper");
    const tabs = section.querySelectorAll(".js-faq-tab");
    const contents = section.querySelectorAll(".js-faq-tab-content");
    const accordions = section.querySelectorAll(".wlsn-accordion");

    // Tab Switching Logic (with the ability to deselect)
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabIndex = tab.dataset.tabIndex;
        const isActive = tab.classList.contains("active");

        // If the tab is already active, deselect it
        if (isActive) {
          tab.classList.remove("active");
          contents.forEach((content) => content.classList.remove("active"));

          // Remove the active class from the wrapper if there are no active tabs
          if (tabsWrapper) {
            tabsWrapper.classList.remove("active");
          }
          return;
        }

        // Remove the active class from all tabs and content sections
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((content) => content.classList.remove("active"));

        // Activate the clicked tab and its corresponding content
        tab.classList.add("active");
        const matchedContent = section.querySelector(
          `.js-faq-tab-content[data-faq-index="${tabIndex}"]`
        );
        if (matchedContent) {
          matchedContent.classList.add("active");

          setTimeout(() => {
            matchedContent.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 100);
        }

        // Add the active class to the parent wrapper when a tab is selected
        if (tabsWrapper) {
          tabsWrapper.classList.add("active");
        }
      });
    });

    // Accordion Toggle Logic (Only affects its own section)
    accordions.forEach((accordion) => {
      const panel = accordion.querySelector(".wlsn-accordion__panel");

      accordion.addEventListener("click", (event) => {
        // Prevent closing the accordion if clicking inside a modal or trigger
        if (
          event.target.closest(".js-video-modal") ||
          event.target.closest(".js-video-modal-trigger")
        ) {
          event.stopPropagation();
          return;
        }

        const isOpen = accordion.classList.contains("show-text");

        if (isOpen) {
          accordion.classList.remove("show-text");
          panel.style.maxHeight = null;
        } else {
          accordion.classList.add("show-text");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });

      // Video Modal Logic (Scoped per accordion panel)
      const modalTrigger = panel.querySelector(".js-video-modal-trigger");
      const videoModal = panel.querySelector(".js-video-modal");
      const videoOverlay = panel.querySelector(".js-video-modal-overlay");
      const video = videoModal ? videoModal.querySelector("video") : null;

      if (videoModal && modalTrigger) {
        // Open the modal when clicking on a trigger
        modalTrigger.addEventListener("click", (event) => {
          event.stopPropagation(); // Prevents closing the accordion
          videoModal.classList.add("active");
        });

        // Close the modal when clicking on the overlay
        if (videoOverlay) {
          videoOverlay.addEventListener("click", () => {
            videoModal.classList.remove("active");
            if (video) {
              video.pause();
              video.classList.remove("active");
            }
          });
        }

        // Play/Pause video when clicking on it
        if (video) {
          video.addEventListener("click", () => {
            if (video.paused) {
              video.play();
              video.classList.add("active");
            } else {
              video.pause();
              video.classList.remove("active");
            }
          });
        }
      }
    });
  });

  // Find all links on the page
  const links = document.querySelectorAll(
    'a[href*="youtube.com"], a[href*="youtu.be"]'
  );

  // Loop through each YouTube link
  links.forEach((link) => {
    // Add target="_blank" to open in a new tab
    link.setAttribute("target", "_blank");

    // Add rel="noopener" for security
    link.setAttribute("rel", "noopener");

    // Add aria-describedby for accessibility
    link.setAttribute("aria-describedby", "a11y-new-window-external-message");
  });
});
